let styles = {
    container: {
        background: 'white',
        padding: '2%',
        display: 'flex',
        justifyContent: 'center',
    },
    main_header: {
        padding:'0px',
        margin:'10px 0px',
        display:'flex',
        background: '#7d3cff',
    },
    title: {
        padding:'5px',
        textAlign:'center',
        borderRadius:'0px'
    },
    row: {
        margin:'1% 0%',
        fontSize:'15px',
        fontWeight:'600'
    },
    table_header: {
        marginTop:'1%',
        padding:10,
        display:"flex",
        fontWeight:'600',
        color:'black'
    },
    table: {
        marginTop:'0%'
    },
    header: {
        marginBottom:'0%'
    },
    date: {
        display: 'flex',
        padding: 0,
        marginBottom:'2%',
    }

  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/customerFeedback/style.js